import React, { useState, useEffect } from 'react';
import MultiplayerGame from './MultiplayerGame';
import { getDifficultyFromGamesPlayed, AI_DIFFICULTY } from '../multiplayer/AIOpponent';

// Friendly AI names - organized by difficulty for personality
const AI_NAMES_BY_DIFFICULTY = {
  easy: {
    names: ['Pip', 'Sunny', 'Buddy', 'Clover', 'Buttons', 'Pebbles', 'Biscuit', 'Maple'],
    titles: ['the Cheerful', 'the Friendly', 'the Curious', 'the Eager']
  },
  medium: {
    names: ['Luna', 'Nova', 'Sage', 'River', 'Quinn', 'Atlas', 'Ember', 'Phoenix'],
    titles: ['the Wise', 'the Swift', 'the Bold', 'the Clever']
  },
  hard: {
    names: ['Raven', 'Storm', 'Cipher', 'Onyx', 'Blaze', 'Vex', 'Nyx', 'Zephyr'],
    titles: ['the Cunning', 'the Strategic', 'the Calculating', 'the Fierce']
  },
  expert: {
    names: ['Archon', 'Nexus', 'Apex', 'Zenith', 'Oracle', 'Aegis', 'Titan', 'Prism'],
    titles: ['the Mastermind', 'the Undefeated', 'the Supreme', 'the Legendary']
  }
};

// Generate a random AI name based on difficulty
const generateAIName = (difficulty) => {
  const nameSet = AI_NAMES_BY_DIFFICULTY[difficulty] || AI_NAMES_BY_DIFFICULTY.medium;
  const firstName = nameSet.names[Math.floor(Math.random() * nameSet.names.length)];
  // 40% chance to add a title
  if (Math.random() < 0.4) {
    const title = nameSet.titles[Math.floor(Math.random() * nameSet.titles.length)];
    return `${firstName} ${title}`;
  }
  return firstName;
};

// Get difficulty label for display
const getDifficultyLabel = (difficulty) => {
  switch (difficulty) {
    case AI_DIFFICULTY.EASY: return 'Beginner';
    case AI_DIFFICULTY.MEDIUM: return 'Intermediate';
    case AI_DIFFICULTY.HARD: return 'Advanced';
    case AI_DIFFICULTY.EXPERT: return 'Expert';
    default: return 'Unknown';
  }
};

const MultiplayerWrapper = ({ onExit }) => {
  const [gameConfig, setGameConfig] = useState(null);

  // Initialize game immediately on mount
  useEffect(() => {
    // Get games played from localStorage for progressive difficulty
    const gamesPlayed = parseInt(localStorage.getItem('versusGamesPlayed') || '0', 10);
    const playerName = localStorage.getItem('playerName') || 'Player';
    
    // Use intelligent difficulty progression
    const difficulty = getDifficultyFromGamesPlayed(gamesPlayed);
    
    // Generate AI name that matches difficulty personality
    const aiName = generateAIName(difficulty);
    
    // Log difficulty info for debugging
    console.log(`Versus Mode: Games played: ${gamesPlayed}, Difficulty: ${getDifficultyLabel(difficulty)}, AI: ${aiName}`);
    
    // Create game config
    const config = {
      mode: 'ai',
      playerName: playerName,
      aiDifficulty: difficulty,
      gamesPlayed: gamesPlayed,
      players: [
        { id: 'player1', name: playerName, isAI: false },
        { id: 'ai1', name: aiName, isAI: true, difficulty: difficulty }
      ]
    };
    
    setGameConfig(config);
  }, []);

  const handleExitGame = () => {
    // Increment games played counter
    const gamesPlayed = parseInt(localStorage.getItem('versusGamesPlayed') || '0', 10);
    localStorage.setItem('versusGamesPlayed', (gamesPlayed + 1).toString());
    
    // Return to home
    onExit();
  };

  if (gameConfig) {
    return <MultiplayerGame gameConfig={gameConfig} onExit={handleExitGame} />;
  }

  // Show loading while initializing
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      color: 'white',
      fontSize: '18px'
    }}>
      Loading...
    </div>
  );
};

export default MultiplayerWrapper;

